import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import AdminContent from "./AdminContent";
import AdminContracts from "./AdminContracts";
import { useAdminSession } from "../context/AdminSessionContext";
import { hasPermission } from "../utils/permissionHelpers";
import WorkspaceShell from "../Components/ui/WorkspaceShell";
import InfoMarkerHint from "../Components/ui/InfoMarkerHint";

type ContentTabKey = "content" | "contracts";

export default function AdminWorkspaceContent() {
  const [params, setParams] = useSearchParams();
  const { session } = useAdminSession();
  const permissions = useMemo(() => session?.permissions ?? [], [session?.permissions]);

  const tabs = useMemo(
    () =>
      [
        { key: "content", label: "Content 360", allow: hasPermission(permissions, "Content.View"), render: <AdminContent /> },
        { key: "contracts", label: "Contracts", allow: hasPermission(permissions, "Contracts.View"), render: <AdminContracts /> },
      ] as const,
    [permissions],
  );

  const available = tabs.filter((tab) => tab.allow);
  const requested = (params.get("tab") ?? "content") as ContentTabKey;
  const active = available.find((tab) => tab.key === requested) ?? available[0];

  if (!active) {
    return <div className="admin-soft-alert text-sm">Bu workspace icin yetkin bulunmuyor.</div>;
  }

  const setTab = (key: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", key);
    setParams(next, { replace: true });
  };

  return (
    <WorkspaceShell
      title="Content 360"
      subtitle="Seri, bolum, ownership, moderasyon kuyrugu ve yayin akislari tek bir modern operasyon panelinde."
      tabs={available.map((tab) => ({ key: tab.key, label: tab.label }))}
      activeKey={active.key}
      onTabChange={setTab}
      statPills={
        <>
          <span className="admin-pill">Queue-first moderasyon</span>
          <span className="admin-pill">Bulk aksiyonlar</span>
          <span className="admin-pill">Ownership transfer</span>
          <span className="admin-pill inline-flex items-center gap-1">
            Kurallar
            <InfoMarkerHint markerKey="creator.upload.rules" />
          </span>
        </>
      }
    >
      {active.render}
    </WorkspaceShell>
  );
}
